import Vue from 'vue'

const STORAGE_KEY = 'eating_admin_ui_mode'

function readStoredTabletMode() {
  try {
    return String(localStorage.getItem(STORAGE_KEY) || '') === 'tablet'
  } catch (_e) {
    return false
  }
}

/** 全局响应式 UI 模式，切换不刷新页面 */
const uiMode = Vue.observable({
  isTabletMode: readStoredTabletMode()
})

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, uiMode.isTabletMode ? 'tablet' : 'web')
  } catch (_e) {}
  if (typeof document !== 'undefined' && document.body) {
    document.body.classList.toggle('tablet-mode', !!uiMode.isTabletMode)
    document.documentElement.classList.toggle('tablet-mode', !!uiMode.isTabletMode)
  }
}

function setTabletMode(on) {
  const next = !!on
  if (uiMode.isTabletMode === next) return
  uiMode.isTabletMode = next
  persist()
}

function toggleTabletMode() {
  setTabletMode(!uiMode.isTabletMode)
}

function applyTabletModeClass() {
  persist()
}

persist()

export { uiMode, setTabletMode, toggleTabletMode, applyTabletModeClass, STORAGE_KEY }
